import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("App error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main
          className="min-h-screen flex items-center justify-center px-6 bg-[#09090B] text-[#F5F5F0]"
          data-testid="error-boundary"
        >
          <div className="text-center max-w-md">
            <p className="text-xs uppercase tracking-[0.3em] text-[#B69B7D] mb-5">AB fëlise shop</p>
            <h1 className="font-serif font-light text-4xl mb-6">Qualcosa non ha funzionato</h1>
            <p className="text-[#A1A1AA] mb-10 leading-relaxed">
              Si è verificato un errore imprevisto. Ricarica la pagina per continuare.
            </p>
            <button
              onClick={() => window.location.reload()}
              data-testid="error-reload-btn"
              className="h-13 px-9 py-4 rounded-full bg-[#B69B7D] text-[#09090B] text-xs uppercase tracking-[0.25em] font-medium"
            >
              Ricarica la pagina
            </button>
          </div>
        </main>
      );
    }
    return this.props.children;
  }
}
